<form #form="ngForm">
  <spk-card [class]="'col-md-5'" meta="{{ getActionText() }} Application Setting" title="{{model.Name}}" [divider]="true">
    <spk-textarea name="Value" [(model)]="model.Value" [rows]="12" [maxlength]="8000"></spk-textarea>
  </spk-card>
</form>
